module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"coupons":{"sub_title":"Available coupons","expires_at":"Expiration date: Until {0}","unlimited":"Expiration date: No expiry"},"button":"View my coupons","hint":"*Depending on the expiration time, coupons that have already expired may be displayed. Click the \u0027View my coupons\u0027 button for more accurate verification."}}')
  delete Component.options._Ctor
}
